export default __webpack_public_path__ + "static/media/gm-awc-girl.4d219344.webp";